<script setup lang="ts">
/** État vide utile (spec §9) : explique quoi faire et propose l'action. Jamais d'illustration générique. */
import type { IconName } from '../icons/registry'
import Icon from './Icon.vue'

defineProps<{ icon: IconName; title: string; message: string }>()
</script>

<template>
  <div class="flex flex-col items-center gap-3 px-4 py-10 text-center">
    <span
      class="flex size-14 items-center justify-center rounded-full bg-surface text-ink-muted"
      aria-hidden="true"
    >
      <Icon :name="icon" :size="24" />
    </span>
    <p class="text-section text-ink">{{ title }}</p>
    <p class="max-w-72 text-body text-ink-muted">{{ message }}</p>
    <div v-if="$slots.action" class="mt-2 w-full max-w-72"><slot name="action" /></div>
  </div>
</template>
